(function() {
  const WHATSAPP_PHONE = "393420431297"; //

  const SHAPES = {
    vulcan: {
      name: "Vulcan",
      isAsymmetrical: false,
      aspectRatio: 1133.86 / 728.91,
      viewBox: "0 0 1133.86 728.91",
      transform: "translate(-141.73 -344.21)",
      d: "M146.51,1011l285-623.38c5.44-11.91,14.58-17.73,23.54-15L557.3,404a19,19,0,0,1,6.92,4l104.86,92.25c7.76,6.83,17.19,6.12,24.54-1.84L829.83,350.71c4.55-4.93,10-7.17,15.45-6.33l169.14,26.09c7.4,1.14,14,7.84,18,18.11l239.53,625c9.93,25.92-1.5,59.53-20.23,59.53H165.63C146,1073.12,134.77,1036.62,146.51,1011Z"
    },
    trapezio: {
      name: "Trapezio",
      isAsymmetrical: false,
      aspectRatio: 1105.51 / 829.13,
      viewBox: "0 0 1105.51 829.13",
      transform: "translate(-155.91 -294.09)",
      d: "M1260.77,655.67a30,30,0,0,0-11-21.37,103.4,103.4,0,0,0-8.27-9.35c-24.67-24.9-296.83-310.69-296.83-310.69s-7.38-10.1-23.2-16a27.35,27.35,0,0,0-14.38-4.18H509.77a27.4,27.4,0,0,0-15.58,4.85c-14.65,6-21.54,15.32-21.54,15.32S200.5,600.05,175.82,625a107.6,107.6,0,0,0-7.3,8.15,30.15,30.15,0,0,0-12.61,24.76v435.59c0,16.44,12.68,29.78,28.33,29.78h1048.4c15.65,0,28.34-13.34,28.34-29.78V665.27S1262.09,661.84,1260.77,655.67Z"
    },
    tonda: {
      name: "Tonda",
      isAsymmetrical: false,
      aspectRatio: 1.0,
      viewBox: "0 0 935.43 935.43",
      transform: "",
      isCircle: true,
      cx: "467.72",
      cy: "467.72",
      r: "467.72"
    },
    spicchio: {
      name: "Spicchio",
      isAsymmetrical: false,
      aspectRatio: 1133.86 / 1022.93,
      viewBox: "0 0 1133.86 1022.93",
      transform: "translate(-141.73 -197.19)",
      d: "M706.06,1219.87c-121,0-242.07-1.06-363.08.24-182.46,2-247.54-165.2-167.58-294.44C299.86,724.51,413.25,516.52,532.07,311.84,620.7,159.17,795.75,159,883.8,311.23c119.37,206.39,233.38,416.08,358.92,618.64,85.77,138.39-5.39,295.3-168.31,290-1.76-.06-3.51,0-5.27,0Z"
    },
    smussa: {
      name: "Smussa",
      isAsymmetrical: false,
      aspectRatio: 1077.17 / 769.35,
      viewBox: "0 0 1077.17 769.35",
      transform: "translate(-170.08 -323.99)",
      d: "M710.51,324C830,331.33,949.91,335.37,1069,347.1c92,9.06,150.76,73.34,163.89,164.77a1384.14,1384.14,0,0,1-.35,399.46c-13.11,89.49-77,155.07-165.94,164a3551.49,3551.49,0,0,1-718-.37c-84.28-8.63-147.77-69.84-161.48-153.87C164.58,782.75,164.6,643.78,186,505.33c13.84-89.74,73.93-150,165.28-158.66C470.42,335.41,590.28,331.25,710.51,324Z"
    },
    rettangolare: {
      name: "Rettangolare",
      isAsymmetrical: false,
      aspectRatio: 1105.51 / 829.13,
      viewBox: "0 0 1105.51 829.13",
      transform: "translate(-155.91 -294.09)",
      d: "M1261.42,1110c0,7.29-5.08,13.21-11.35,13.21H167.25c-6.26,0-11.34-5.92-11.34-13.21V307.31c0-7.3,5.08-13.22,11.34-13.22H1250.07c6.27,0,11.35,5.92,11.35,13.22Z"
    },
    reale: {
      name: "Reale",
      isAsymmetrical: false,
      aspectRatio: 1020.47 / 775.66,
      viewBox: "0 0 1020.47 775.66",
      transform: "translate(-198.43 -320.83)",
      d: "M1165.87,563.14,1000.2,397.47a141,141,0,0,0-47.66-31.42c-97.67-38.8-192.66-44.54-228.69-45.22H693.48c-12.09.23-30.81,1-54,3.45h0q-7.83.81-16.31,1.89c-44.33,5.65-101.21,17.1-159,40.14a139.86,139.86,0,0,0-47,31.15L251.45,563.14a141.19,141.19,0,0,0-35,57.72,401.79,401.79,0,0,0-18,119.52V977.29c0,65.83,53.1,119.2,118.62,119.2h783.22c65.52,0,118.63-53.37,118.63-119.2V740.38a401.48,401.48,0,0,0-18-119.52A141.19,141.19,0,0,0,1165.87,563.14Z"
    },
    quadrata: {
      name: "Quadrata",
      isAsymmetrical: false,
      aspectRatio: 878.74 / 875.71,
      viewBox: "0 0 878.74 875.71",
      transform: "translate(-269.29 -270.81)",
      d: "M707.81,1145.89c-128.73,0-257.47-1-386.19.61-39,.49-52.5-13.54-52.33-52.44q1.71-386.19.08-772.4c-.14-36.26,11.88-51,49.21-50.85q390.67,1.37,781.37.07c34.6-.1,48.17,13.22,48.08,47.73q-1,390.67-.06,781.37c.08,35.34-15.69,46.65-49.47,46.36C968.28,1145.22,838,1145.89,707.81,1145.89Z"
    },
    ovale: {
      name: "Ovale",
      isAsymmetrical: false,
      aspectRatio: 1105.51 / 807.87,
      viewBox: "0 0 1105.51 807.87",
      transform: "translate(-155.91 -304.72)",
      d: "M1261.42,708.66c0,223.09-182.56,403.94-407.75,403.94h-290c-225.2,0-407.75-180.85-407.75-403.94h0c0-223.09,182.55-403.94,407.75-403.94h290c225.19,0,407.75,180.85,407.75,403.94Z"
    },
    ottagono: {
      name: "Ottagono",
      isAsymmetrical: false,
      aspectRatio: 992.13 / 992.13,
      viewBox: "0 0 992.13 992.13",
      transform: "translate(-212.6 -212.6)",
      d: "M1192.31,490.77,922.4,220.86a28.22,28.22,0,0,0-19.95-8.26H514.87a28.22,28.22,0,0,0-19.95,8.26L220.86,494.92a28.22,28.22,0,0,0-8.26,19.95V902.45a28.19,28.19,0,0,0,8.26,19.94l274.06,274.07a28.22,28.22,0,0,0,19.95,8.26H902.45a28.22,28.22,0,0,0,19.95-8.26l274.06-274.07a28.19,28.19,0,0,0,8.26-19.94V520.75A42.38,42.38,0,0,0,1192.31,490.77Z"
    },
    goccia: {
      name: "Goccia",
      isAsymmetrical: true,
      aspectRatio: 1133.86 / 951.74,
      viewBox: "0 0 1133.86 951.74",
      transform: "translate(-141.73 -232.79)",
      d: "M392.7,337.27c17.64-18.31,22.31-25,45.53-43.55S569.5,184.79,732.92,266.37c122.35,62.58,340,226,428.43,332.36S1417.87,977,1037.44,1136.9c-92.43,37.54-397.84,89-683.16-8.35-166.1-54.23-254.51-211.37-192.89-403.28C205.6,586.21,328.59,403.85,392.7,337.27Z"
    },
    cloche: {
      name: "Cloche",
      isAsymmetrical: false,
      aspectRatio: 1133.86 / 951.74,
      viewBox: "0 0 1133.86 951.74",
      transform: "translate(-141.73 -232.79)",
      d: "M392.7,337.27c17.64-18.31,22.31-25,45.53-43.55S569.5,184.79,732.92,266.37c122.35,62.58,340,226,428.43,332.36S1417.87,977,1037.44,1136.9c-92.43,37.54-397.84,89-683.16-8.35-166.1-54.23-254.51-211.37-192.89-403.28C205.6,586.21,328.59,403.85,392.7,337.27Z"
    },
    classic: {
      name: "Classic",
      isAsymmetrical: false,
      aspectRatio: 1190.55 / 877.25,
      viewBox: "0 0 1190.55 877.25",
      transform: "translate(-113.39 -270.04)",
      d: "M1210.64,567.13A312.27,312.27,0,0,1,1006.26,363,159,159,0,0,0,894.07,270H523.76A158.86,158.86,0,0,0,405.51,379.49l.47-2.19A312.35,312.35,0,0,1,207.14,566.91a158.75,158.75,0,0,0-93.75,132.67v319.33c0,70.9,78,128.38,174.22,128.38h842.1c96.22,0,174.23-57.48,174.23-128.38V699.58A158.77,158.77,0,0,0,1210.64,567.13Z"
    },
    casale: {
      name: "Casale",
      isAsymmetrical: false,
      aspectRatio: 1162.2 / 870.21,
      viewBox: "0 0 1162.2 870.21",
      transform: "translate(-127.56 -273.56)",
      d: "M711.72,1143.48c-141.6,0-283.21.44-424.81-.1C186.64,1143,129.07,1085.54,128.15,985q-1.22-131.91,0-263.83c.73-84.7,38.22-131.13,119.49-156,14.7-4.51,30.79-17.47,38.13-31,91.28-167.5,230.35-259.71,422-260.57,193.72-.87,333.72,92.29,426.65,260.69,7.91,14.34,26.23,27.2,42.33,32,74.17,22.29,112.14,68.87,112.65,146.31.61,93.88.45,187.76.05,281.64-.39,89.09-58,148.11-148.41,148.89C997.92,1144.35,854.82,1143.44,711.72,1143.48Z"
    },
    campana: {
      name: "Campana",
      isAsymmetrical: false,
      aspectRatio: 1133.86 / 859.39,
      viewBox: "0 0 1133.86 859.39",
      transform: "translate(-141.73 -278.97)",
      d: "M711.5,1137.51c-155.19,0-310.39-.63-465.57.58-28.36.22-44.16-7.45-56-34.93C41.69,759.06,249.88,359.93,616,288.27c285.22-55.83,578.49,145.63,644.14,441.31,27.87,125.54,17.71,247.31-27,367.38-11.13,29.88-26.94,41.79-60.34,41.39C1019,1136.46,865.24,1137.52,711.5,1137.51Z"
    },
    cammeo: {
      name: "Cammeo",
      isAsymmetrical: false,
      aspectRatio: 1133.86 / 797.39,
      viewBox: "0 0 1133.86 797.39",
      transform: "translate(-141.73 -309.97)",
      d: "M699.9,310c164.32.66,307.59,36.4,430.69,132.16,194.46,151.27,193.26,386.37-3.18,534.75-152,114.85-327.22,144.67-512.11,124.74-134-14.44-258.34-57.83-358.29-152.8-161.72-153.68-152.33-362,22.13-501.08C405.07,347.31,552.07,310.29,699.9,310Z"
    },
    burger: {
      name: "Burger",
      isAsymmetrical: false,
      aspectRatio: 935.43 / 870.92,
      viewBox: "0 0 935.43 870.92",
      transform: "translate(-240.94 -273.2)",
      d: "M1176.35,984.93V724h-.44c.19-5.1.3-10.23.3-15.37,0-240.49-209.35-435.45-467.58-435.45S241,468.16,241,708.65c0,5.14.11,10.27.3,15.37H241V984.93s-1.57,69.07,17.23,94.73,51.19,64.46,114.91,64.46h671.09c63.72,0,96.1-38.81,114.9-64.46S1176.35,984.93,1176.35,984.93Z"
    }
  }; //[cite: 1]

  const COLOR_PALETTES = {
    satinato: [
      { code: "S3", name: "S3 Oliva", hex: "#70795c" },
      { code: "S4", name: "S4 Verdebosco", hex: "#48534b" },
      { code: "S5", name: "S5 Blucarbon", hex: "#5b7385" },
      { code: "S6", name: "S6 Blucaldo", hex: "#4b6574" },
      { code: "S7", name: "S7 Bordeaux", hex: "#632737" },
      { code: "S10", name: "S10 Moro", hex: "#4b3c38" },
      { code: "S12", name: "S12 Nero", hex: "#2b2a2b" }
    ],
    lucido: [
      { code: "L3", name: "L3 Giallo", hex: "#e5cb52" },
      { code: "L4", name: "L4 Arancio", hex: "#e57f35" },
      { code: "L5", name: "L5 Rosso", hex: "#c7436b" },
      { code: "L6", name: "L6 Verdeacido", hex: "#99cc45" },
      { code: "L7", name: "L7 Turchese", hex: "#45aec5" }
    ],
    "soft-opaco": [
      { code: "R1", name: "R1 Beige", hex: "#f1ede1" },
      { code: "R2", name: "R2 Cra", hex: "#caa781" },
      { code: "R3", name: "R3 Tortora", hex: "#63544d" },
      { code: "R4", name: "R4 Marrone", hex: "#8c5c3e" },
      { code: "R5", name: "R5 Grigio", hex: "#585657" },
      { code: "R6", name: "R6 Nero", hex: "#312a29" }
    ],
    "soft-lucido": [
      { code: "SM1", name: "SM1 Oldpink", hex: "#d0a7bd" },
      { code: "SM2", name: "SM2 Fucsia", hex: "#bc3b8b" },
      { code: "SM3", name: "SM3 Cipria", hex: "#e3cfb9" },
      { code: "SM4", name: "SM4 Rosso", hex: "#a43350" },
      { code: "SM5", name: "SM5 Acciaio", hex: "#a7a6ad" },
      { code: "SM6", name: "SM6 Silvergreen", hex: "#91ab9d" },
      { code: "SM9", name: "SM9 Smeraldo", hex: "#35a6a6" },
      { code: "SM10", name: "SM10 Nero", hex: "#393838" },
      { code: "SM11", name: "SM11 Bronzo", hex: "#8c5643" },
      { code: "SM12", name: "SM12 Bluette", hex: "#1651a1" },
      { code: "SM7", name: "SM7 Antracite", hex: "#736b6b" },
      { code: "SM8", name: "SM8 Oro", hex: "#e5c363" }
    ]
  }; //[cite: 1]

  const state = {
    shapeKey: "ottagono", //[cite: 1]
    activeSide: "A", //[cite: 1]
    sideA: { finish: "satinato", colorHex: "#70795c", colorName: "S3 Oliva" }, //[cite: 1]
    sideB: { finish: "soft-opaco", colorHex: "#8c5c3e", colorName: "R4 Marrone" }, //[cite: 1]
    tableDimMode: "preset", //[cite: 1]
    tablePreset: "80x80", //[cite: 1]
    tableWidthCm: 80, //[cite: 1]
    tableHeightCm: 80, //[cite: 1]
    tableSeats: 4, //[cite: 1]
    orderQuantity: 50, //[cite: 1]
    computedWidthCm: 45, //[cite: 1]
    computedHeightCm: 32, //[cite: 1]
    brandingMode: "text", //[cite: 1]
    brandingText: "IL TUO LOGO", //[cite: 1]
    brandingFont: "'Cinzel', serif", //[cite: 1]
    brandingTechnique: "laser", //[cite: 1]
    logoWidthCm: 6.0, // Max 8 cm come da richiesta[cite: 1]
    logoPosNorm: { x: 0.5, y: 0.15 }, // Posizione percentuale normalizzata (0..1) per il drag interattivo
    uploadedLogoSrc: null, //[cite: 1]
    tableMaterial: "table-noce", //[cite: 1]
    tablePhotoUrl: null, //[cite: 1]
    selectedAccessories: [], //[cite: 1]
    viewMode: "single" //[cite: 1]
  };

  let isDraggingLogo = false;
  let dragStartMouse = { x: 0, y: 0 };
  let dragStartLogoPos = { x: 0.5, y: 0.15 };

  let svgRootElement, svgBaseShape, svgFinishOverlay, svgFlipContainer, svgBrandingGroup; //[cite: 1]
  let brandingText, brandingImage; //[cite: 1]
  let shapesContainer, swatchesContainer, customColorPicker, customHexLabel, mirrorIndicator; //[cite: 1]
  let singleViewContainer, tableSimulationContainer, tableTopBounds, seatsPlacematsWrapper, centerFreeSpace; //[cite: 1]
  let tagShape, tagColor, selectedShapeName, labelActiveSide, placematComputedDim, safetyCalculationText; //[cite: 1]
  let labelLogoWidth, previewDotA, previewDotB, badgeSeatsDisplay; //[cite: 1]
  let sumShape, sumDim, sumSideA, sumSideB, sumTech, sumTable, sumAccessories, sumQuantity, sumTablePhoto; //[cite: 1]
  let stickySummary; //[cite: 1]

  function injectLaserFilter() {
    let defs = svgRootElement.querySelector("defs");
    if (!defs) {
      defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
      svgRootElement.prepend(defs);
    }
    
    // Filtro incisione a fuoco senza ombre blurrate sotto, effetto bruciatura termica + debole deboss
    const filterId = "laserBurnEffect";
    if (!document.getElementById(filterId)) {
      const filter = document.createElementNS("http://www.w3.org/2000/svg", "filter");
      filter.setAttribute("id", filterId);
      filter.setAttribute("x", "-10%");
      filter.setAttribute("y", "-10%");
      filter.setAttribute("width", "120%");
      filter.setAttribute("height", "120%");
      filter.innerHTML = `
        <feColorMatrix type="matrix" values="
          0.28 0  0 0 0.11
          0 0.22 0 0 0.08
          0 0 0.18 0 0.05
          0 0 0 0.95 0" in="SourceGraphic" result="burned" />
        <feComponentTransfer in="SourceAlpha" result="alpha">
          <feFuncA type="linear" slope="1"/>
        </feComponentTransfer>
        <feDropShadow dx="0" dy="0.7" stdDeviation="0.4" flood-color="#ffffff" flood-opacity="0.25" result="lightDeboss"/>
        <feMerge>
          <feMergeNode in="lightDeboss" />
          <feMergeNode in="burned" />
        </feMerge>
      `;
      defs.appendChild(filter);
    }
  }

  function calculateProportions() {
    let tw = 80, th = 80; //[cite: 1]
    if (state.tableDimMode === "custom") { //[cite: 1]
      tw = parseFloat(document.getElementById("input-custom-width").value) || 80; //[cite: 1]
      th = parseFloat(document.getElementById("input-custom-height").value) || 80; //[cite: 1]
    } else {
      const p = state.tablePreset; //[cite: 1]
      if (p === "80x80") { tw = 80; th = 80; } //[cite: 1]
      else if (p === "90x90") { tw = 90; th = 90; } //[cite: 1]
      else if (p === "70x70") { tw = 70; th = 70; } //[cite: 1]
      else if (p === "80x70") { tw = 80; th = 70; } //[cite: 1]
      else if (p === "120x80") { tw = 120; th = 80; } //[cite: 1]
      else if (p === "140x80") { tw = 140; th = 80; } //[cite: 1]
      else if (p === "160x90") { tw = 160; th = 90; } //[cite: 1]
      else if (p.indexOf("diam") === 0) { //[cite: 1]
        const sz = parseInt(p.split("-")[1]) || 80; //[cite: 1]
        tw = sz; th = sz; //[cite: 1]
      }
    }

    state.tableWidthCm = Math.max(40, tw); //[cite: 1]
    state.tableHeightCm = Math.max(40, th); //[cite: 1]

    const seats = parseInt(state.tableSeats); //[cite: 1]
    const activeShape = SHAPES[state.shapeKey]; //[cite: 1]
    const ratio = activeShape.aspectRatio || (45 / 32); //[cite: 1]

    let maxW, maxH; //[cite: 1]
    let centerClearance = 0; //[cite: 1]

    if (seats >= 4) { //[cite: 1]
      const availableHalf = Math.min(state.tableWidthCm, state.tableHeightCm) / 2; //[cite: 1]
      maxH = Math.min(32, Math.max(20, availableHalf - 10)); //[cite: 1]
      maxW = Math.min(45, maxH * ratio); //[cite: 1]
      if (maxW > 45) { maxW = 45; maxH = maxW / ratio; } //[cite: 1]

      const seatsPerSide = Math.ceil(seats / 2); //[cite: 1]
      const maxAllowedWidthPerSeat = (Math.max(state.tableWidthCm, state.tableHeightCm) / seatsPerSide) - 6; //[cite: 1]
      if (maxW > maxAllowedWidthPerSeat) { //[cite: 1]
        maxW = Math.max(25, Math.min(45, maxAllowedWidthPerSeat)); //[cite: 1]
        maxH = maxW / ratio; //[cite: 1]
      }
      centerClearance = Math.round(Math.min(state.tableWidthCm, state.tableHeightCm) - (maxH * 2)); //[cite: 1]
    } else if (seats === 2 || seats === 3) { //[cite: 1]
      const availableDepth = state.tableHeightCm / 2; //[cite: 1]
      maxH = Math.min(33, Math.max(22, availableDepth - 6)); //[cite: 1]
      maxW = Math.min(45, state.tableWidthCm - 12); //[cite: 1]
      if (maxW / maxH > ratio) { //[cite: 1]
        maxW = maxH * ratio; //[cite: 1]
      } else {
        maxH = maxW / ratio; //[cite: 1]
      }
      centerClearance = Math.round(state.tableHeightCm - (maxH * 2)); //[cite: 1]
    } else {
      maxW = Math.min(45, state.tableWidthCm - 10); //[cite: 1]
      maxH = Math.min(32, maxW / ratio); //[cite: 1]
      centerClearance = Math.round(state.tableHeightCm - maxH); //[cite: 1]
    }

    state.computedWidthCm = Math.min(45, Math.round(maxW * 2) / 2); //[cite: 1]
    state.computedHeightCm = Math.min(32, Math.round(maxH * 2) / 2); //[cite: 1]

    if (placematComputedDim) placematComputedDim.textContent = state.computedWidthCm.toFixed(1) + " x " + state.computedHeightCm.toFixed(1) + " cm"; //[cite: 1]
    if (centerFreeSpace) centerFreeSpace.textContent = Math.max(10, centerClearance) + " cm"; //[cite: 1]
    if (badgeSeatsDisplay) badgeSeatsDisplay.textContent = seats + " Person" + (seats === 1 ? 'a' : 'e'); //[cite: 1]
    const seatsBtn = document.getElementById("btn-seats-count");
    if (seatsBtn) seatsBtn.textContent = seats; //[cite: 1]

    if (safetyCalculationText) {
      safetyCalculationText.innerHTML = "Su tavolo <strong>" + state.tableWidthCm + "x" + state.tableHeightCm + " cm</strong> (" + seats + " persone), tovaglietta ricalcolata a <strong>" + state.computedWidthCm.toFixed(1) + "x" + state.computedHeightCm.toFixed(1) + " cm</strong> (Max 45 cm, spazio centrale libero: <strong>" + Math.max(10, centerClearance) + " cm</strong>)."; //[cite: 1]
    }

    if (state.viewMode === "table") { //[cite: 1]
      renderTableSimulation(); //[cite: 1]
    }
  }

  function getShapeSvgHtml(key, fillColor) {
    const item = SHAPES[key]; //[cite: 1]
    if (item.isCircle) { //[cite: 1]
      return '<svg viewBox="' + item.viewBox + '" class="w-full h-auto pointer-events-none"><circle cx="' + item.cx + '" cy="' + item.cy + '" r="' + item.r + '" fill="' + fillColor + '" /></svg>'; //[cite: 1]
    } else {
      let content = ''; //[cite: 1]
      if (item.transform) { //[cite: 1]
        content = '<g transform="' + item.transform + '"><path d="' + item.d + '" fill="' + fillColor + '" /></g>'; //[cite: 1]
      } else {
        content = '<path d="' + item.d + '" fill="' + fillColor + '" />'; //[cite: 1]
      }
      return '<svg viewBox="' + item.viewBox + '" class="w-full h-auto pointer-events-none">' + content + '</svg>'; //[cite: 1]
    }
  }

  function initShapeSelector() {
    shapesContainer.innerHTML = ""; //[cite: 1]
    Object.keys(SHAPES).forEach(function(key) {
      const item = SHAPES[key]; //[cite: 1]
      const isSelected = key === state.shapeKey; //[cite: 1]
      const btn = document.createElement("button"); //[cite: 1]
      btn.type = "button"; //[cite: 1]
      btn.className = "p-2 rounded-xl border flex flex-col items-center gap-1.5 transition transform hover:scale-105 active:scale-95 " + (isSelected ? "border-amber-600 bg-amber-50/80 shadow-sm ring-2 ring-amber-500 text-amber-900 font-bold" : "border-slate-200 bg-white hover:border-amber-300 text-slate-700"); //[cite: 1]
      
      const thumbSvg = getShapeSvgHtml(key, isSelected ? '#92400e' : '#64748b'); //[cite: 1]
      btn.innerHTML = '<div class="w-10 h-7 flex items-center justify-center">' + thumbSvg + '</div><span class="text-[10px] tracking-tight pointer-events-none truncate w-full text-center">' + item.name + '</span>'; //[cite: 1]
      
      btn.addEventListener("click", function() { //[cite: 1]
        state.shapeKey = key; //[cite: 1]
        calculateProportions(); //[cite: 1]
        updateRender(); //[cite: 1]
        initShapeSelector(); //[cite: 1]
      });
      shapesContainer.appendChild(btn); //[cite: 1]
    });
  }

  function renderColorSwatches() {
    swatchesContainer.innerHTML = ""; //[cite: 1]
    const currentSide = state.activeSide === "A" ? state.sideA : state.sideB; //[cite: 1]
    const palette = COLOR_PALETTES[currentSide.finish] || COLOR_PALETTES.satinato; //[cite: 1]

    palette.forEach(function(swatch) {
      const isCurrent = currentSide.colorHex.toLowerCase() === swatch.hex.toLowerCase(); //[cite: 1]
      const div = document.createElement("button"); //[cite: 1]
      div.type = "button"; //[cite: 1]
      div.title = swatch.name; //[cite: 1]
      div.className = "w-11 h-11 rounded-full border-2 transition transform hover:scale-110 flex items-center justify-center shadow-md " + (isCurrent ? "border-amber-800 scale-110 ring-4 ring-amber-500/40" : "border-slate-300/80"); //[cite: 1]
      div.style.backgroundColor = swatch.hex; //[cite: 1]
      if (isCurrent) {
        div.innerHTML = '<i class="fa-solid fa-check text-sm text-white drop-shadow-md"></i>'; //[cite: 1]
      }
      div.addEventListener("click", function() { //[cite: 1]
        currentSide.colorHex = swatch.hex; //[cite: 1]
        currentSide.colorName = swatch.name; //[cite: 1]
        customColorPicker.value = swatch.hex; //[cite: 1]
        customHexLabel.textContent = swatch.hex.toUpperCase(); //[cite: 1]
        updateRender(); //[cite: 1]
        renderColorSwatches(); //[cite: 1]
      });
      swatchesContainer.appendChild(div); //[cite: 1]
    });
  }

  function updateAccessoriesSummary() {
    const list = state.selectedAccessories; //[cite: 1]
    if (sumAccessories) { //[cite: 1]
      sumAccessories.textContent = list.length > 0 ? list.join(", ") : "Nessuno"; //[cite: 1]
    }
  }

  function updateRender() {
    const activeShape = SHAPES[state.shapeKey] || SHAPES.ottagono; //[cite: 1]
    const currentSide = state.activeSide === "A" ? state.sideA : state.sideB; //[cite: 1]

    svgRootElement.setAttribute("viewBox", activeShape.viewBox); //[cite: 1]

    if (state.activeSide === "B" && activeShape.isAsymmetrical) { //[cite: 1]
      const parts = activeShape.viewBox.split(" "); //[cite: 1]
      const vbW = parseFloat(parts[2]) || 1000; //[cite: 1]
      svgFlipContainer.setAttribute("transform", "scale(-1, 1) translate(-" + vbW + ", 0)"); //[cite: 1]
      mirrorIndicator.classList.remove("hidden"); //[cite: 1]
      mirrorIndicator.classList.add("flex"); //[cite: 1]
    } else {
      svgFlipContainer.setAttribute("transform", "scale(1, 1) translate(0, 0)"); //[cite: 1]
      mirrorIndicator.classList.add("hidden"); //[cite: 1]
      mirrorIndicator.classList.remove("flex"); //[cite: 1]
    }

    let shapeInnerHtml = ''; //[cite: 1]
    if (activeShape.isCircle) { //[cite: 1]
      shapeInnerHtml = '<circle id="svg-base-shape" cx="' + activeShape.cx + '" cy="' + activeShape.cy + '" r="' + activeShape.r + '" fill="' + currentSide.colorHex + '" />'; //[cite: 1]
    } else if (activeShape.transform) { //[cite: 1]
      shapeInnerHtml = '<g transform="' + activeShape.transform + '"><path id="svg-base-shape" d="' + activeShape.d + '" fill="' + currentSide.colorHex + '" /></g>'; //[cite: 1]
    } else {
      shapeInnerHtml = '<path id="svg-base-shape" d="' + activeShape.d + '" fill="' + currentSide.colorHex + '" />'; //[cite: 1]
    }
    svgFlipContainer.innerHTML = shapeInnerHtml; //[cite: 1]
    svgBaseShape = document.getElementById("svg-base-shape"); //[cite: 1]

    const isGlossy = currentSide.finish === "lucido" || currentSide.finish === "soft-lucido"; //[cite: 1]
    const isSatin = currentSide.finish === "satinato"; //[cite: 1]

    if (svgFinishOverlay) { //[cite: 1]
      if (isGlossy) { //[cite: 1]
        svgFinishOverlay.setAttribute("fill", "url(#glossHighlight)"); //[cite: 1]
        svgFinishOverlay.style.opacity = "0.65";
      } else if (isSatin) {
        svgFinishOverlay.setAttribute("fill", "url(#satinSheen)"); //[cite: 1]
        svgFinishOverlay.style.opacity = "0.35";
      } else {
        svgFinishOverlay.style.opacity = "0"; //[cite: 1]
      }
    }

    if (previewDotA) previewDotA.style.backgroundColor = state.sideA.colorHex; //[cite: 1]
    if (previewDotB) previewDotB.style.backgroundColor = state.sideB.colorHex; //[cite: 1]

    const vbParts = activeShape.viewBox.split(" "); //[cite: 1]
    const vbW = parseFloat(vbParts[2]) || 1000; //[cite: 1]
    const vbH = parseFloat(vbParts[3]) || 1000; //[cite: 1]

    // Conversione cm -> unità interne ViewBox SVG[cite: 1]
    const scaleFactor = vbW / Math.max(30, state.computedWidthCm); //[cite: 1]

    // Limite dimensione: massimo 8 cm effettivi
    const clampedLogoCm = Math.min(8.0, Math.max(2.0, state.logoWidthCm));
    state.logoWidthCm = clampedLogoCm;
    const logoSvgWidth = clampedLogoCm * scaleFactor;
    const logoSvgHeight = logoSvgWidth * 0.45;

    // Vincolo di sicurezza: 2 cm reali dal bordo di taglio[cite: 1]
    const margin2cm = 2.0 * scaleFactor; //[cite: 1]

    const minX = margin2cm + (logoSvgWidth / 2);
    const maxX = vbW - margin2cm - (logoSvgWidth / 2);
    const minY = margin2cm + (logoSvgHeight / 2);
    const maxY = vbH - margin2cm - (logoSvgHeight / 2);

    // Coordinate attuali centrate con vincoli rigidi
    let targetX = state.logoPosNorm.x * vbW;
    let targetY = state.logoPosNorm.y * vbH;

    targetX = Math.max(minX, Math.min(maxX, targetX));
    targetY = Math.max(minY, Math.min(maxY, targetY));

    // Aggiornamento normalizzato
    state.logoPosNorm.x = targetX / vbW;
    state.logoPosNorm.y = targetY / vbH;

    if (svgBrandingGroup) { //[cite: 1]
      svgBrandingGroup.setAttribute("transform", "translate(" + targetX + ", " + targetY + ")"); //[cite: 1]
      svgBrandingGroup.style.cursor = isDraggingLogo ? "grabbing" : "grab";
      svgBrandingGroup.style.mixBlendMode = "multiply";
      svgBrandingGroup.setAttribute("filter", "url(#laserBurnEffect)");
    }

    const fontSizePx = Math.max(12, Math.min(48, logoSvgWidth * 0.22)); //[cite: 1]
    if (state.brandingMode === "text") { //[cite: 1]
      brandingText.classList.remove("hidden"); //[cite: 1]
      brandingImage.classList.add("hidden"); //[cite: 1]
      brandingText.textContent = state.brandingText; //[cite: 1]
      brandingText.style.fontFamily = state.brandingFont; //[cite: 1]
      brandingText.style.fontSize = fontSizePx + "px"; //[cite: 1]
      brandingText.setAttribute("fill", "#261a12"); //[cite: 1]
      brandingText.style.letterSpacing = "0.08em";
      brandingText.style.fontWeight = "700";
    } else if (state.uploadedLogoSrc) { //[cite: 1]
      brandingText.classList.add("hidden"); //[cite: 1]
      brandingImage.classList.remove("hidden"); //[cite: 1]
      brandingImage.setAttribute("href", state.uploadedLogoSrc); //[cite: 1]
      brandingImage.setAttribute("width", logoSvgWidth); //[cite: 1]
      brandingImage.setAttribute("height", logoSvgHeight); //[cite: 1]
      brandingImage.setAttribute("x", -logoSvgWidth / 2); //[cite: 1]
      brandingImage.setAttribute("y", -logoSvgHeight / 2); //[cite: 1]
    }

    if (tagShape) tagShape.textContent = activeShape.name; //[cite: 1]
    if (tagColor) tagColor.textContent = currentSide.colorName; //[cite: 1]
    if (selectedShapeName) selectedShapeName.textContent = activeShape.name; //[cite: 1]

    if (sumShape) sumShape.textContent = activeShape.name; //[cite: 1]
    if (sumDim) sumDim.textContent = state.computedWidthCm.toFixed(1) + " x " + state.computedHeightCm.toFixed(1) + " cm"; //[cite: 1]
    if (sumSideA) sumSideA.textContent = state.sideA.colorName + " (" + state.sideA.finish + ")"; //[cite: 1]
    if (sumSideB) sumSideB.textContent = state.sideB.colorName + " (" + state.sideB.finish + ")"; //[cite: 1]
    
    const logoDesc = "Laser a fuoco (" + state.logoWidthCm.toFixed(1) + " cm max 8cm, pos. interattiva)";
    if (sumTech) sumTech.textContent = logoDesc; //[cite: 1]
    
    if (sumTable) sumTable.textContent = state.tableWidthCm + "x" + state.tableHeightCm + " cm (" + state.tableSeats + " Persone)"; //[cite: 1]
    if (sumQuantity) sumQuantity.textContent = state.orderQuantity + " pezzi"; //[cite: 1]
    if (sumTablePhoto) sumTablePhoto.textContent = state.tablePhotoUrl ? "Caricata (Link pronto)" : "Nessuna"; //[cite: 1]
    updateAccessoriesSummary(); //[cite: 1]

    if (stickySummary) { //[cite: 1]
      stickySummary.textContent = activeShape.name + " • " + state.computedWidthCm.toFixed(1) + "x" + state.computedHeightCm.toFixed(1) + " cm • " + state.orderQuantity + " pz"; //[cite: 1]
    }

    if (state.viewMode === "table") { //[cite: 1]
      renderTableSimulation(); //[cite: 1]
    }
  }

  function initInteractiveLogoDragging() {
    if (!svgBrandingGroup || !svgRootElement) return;

    function getEventPos(e) {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    }

    function onPointerDown(e) {
      e.preventDefault();
      isDraggingLogo = true;
      const pt = getEventPos(e);
      dragStartMouse = pt;
      dragStartLogoPos = { ...state.logoPosNorm };
      svgBrandingGroup.style.cursor = "grabbing";
    }

    function onPointerMove(e) {
      if (!isDraggingLogo) return;
      e.preventDefault();

      const pt = getEventPos(e);
      const rect = svgRootElement.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;

      const deltaXNorm = (pt.x - dragStartMouse.x) / rect.width;
      const deltaYNorm = (pt.y - dragStartMouse.y) / rect.height;

      state.logoPosNorm.x = dragStartLogoPos.x + deltaXNorm;
      state.logoPosNorm.y = dragStartLogoPos.y + deltaYNorm;

      updateRender();
    }

    function onPointerUp() {
      if (!isDraggingLogo) return;
      isDraggingLogo = false;
      if (svgBrandingGroup) svgBrandingGroup.style.cursor = "grab";
    }

    svgBrandingGroup.addEventListener("mousedown", onPointerDown);
    window.addEventListener("mousemove", onPointerMove);
    window.addEventListener("mouseup", onPointerUp);

    svgBrandingGroup.addEventListener("touchstart", onPointerDown, { passive: false });
    window.addEventListener("touchmove", onPointerMove, { passive: false });
    window.addEventListener("touchend", onPointerUp);
  }

  function renderTableSimulation() {
    seatsPlacematsWrapper.innerHTML = ""; //[cite: 1]
    const seats = parseInt(state.tableSeats); //[cite: 1]
    const currentColor = state.activeSide === "A" ? state.sideA.colorHex : state.sideB.colorHex; //[cite: 1]

    const w = state.tableWidthCm; //[cite: 1]
    const h = state.tableHeightCm; //[cite: 1]

    if (w >= h) { //[cite: 1]
      const ratio = w / h; //[cite: 1]
      tableTopBounds.style.width = "90%"; //[cite: 1]
      tableTopBounds.style.height = Math.max(35, Math.round(90 / ratio)) + "%"; //[cite: 1]
    } else {
      const ratio = h / w; //[cite: 1]
      tableTopBounds.style.height = "90%"; //[cite: 1]
      tableTopBounds.style.width = Math.max(35, Math.round(90 / ratio)) + "%"; //[cite: 1]
    }

    if (state.tablePreset.indexOf("diam") === 0) { //[cite: 1]
      tableTopBounds.style.borderRadius = "9999px"; //[cite: 1]
    } else {
      tableTopBounds.style.borderRadius = "1rem"; //[cite: 1]
    }

    const positions = []; //[cite: 1]
    if (seats === 1) positions.push({ style: "bottom: 12px; left: 50%; transform: translateX(-50%); width: 42%;" }); //[cite: 1]
    else if (seats === 2) { //[cite: 1]
      positions.push({ style: "bottom: 10px; left: 50%; transform: translateX(-50%); width: 36%;" }); //[cite: 1]
      positions.push({ style: "top: 10px; left: 50%; transform: translateX(-50%) rotate(180deg); width: 36%;" }); //[cite: 1]
    } else if (seats === 3) { //[cite: 1]
      positions.push({ style: "bottom: 10px; left: 32%; transform: translateX(-50%); width: 30%;" }); //[cite: 1]
      positions.push({ style: "bottom: 10px; left: 68%; transform: translateX(-50%); width: 30%;" }); //[cite: 1]
      positions.push({ style: "top: 10px; left: 50%; transform: translateX(-50%) rotate(180deg); width: 30%;" }); //[cite: 1]
    } else if (seats === 4) { //[cite: 1]
      positions.push({ style: "bottom: 8px; left: 50%; transform: translateX(-50%); width: 32%;" }); //[cite: 1]
      positions.push({ style: "top: 8px; left: 50%; transform: translateX(-50%) rotate(180deg); width: 32%;" }); //[cite: 1]
      positions.push({ style: "left: -6px; top: 50%; transform: translateY(-50%) rotate(90deg); width: 32%;" }); //[cite: 1]
      positions.push({ style: "right: -6px; top: 50%; transform: translateY(-50%) rotate(-90deg); width: 32%;" }); //[cite: 1]
    } else if (seats === 6) { //[cite: 1]
      positions.push({ style: "bottom: 8px; left: 20%; transform: translateX(-50%); width: 24%;" }); //[cite: 1]
      positions.push({ style: "bottom: 8px; left: 50%; transform: translateX(-50%); width: 24%;" }); //[cite: 1]
      positions.push({ style: "bottom: 8px; left: 80%; transform: translateX(-50%); width: 24%;" }); //[cite: 1]
      positions.push({ style: "top: 8px; left: 20%; transform: translateX(-50%) rotate(180deg); width: 24%;" }); //[cite: 1]
      positions.push({ style: "top: 8px; left: 50%; transform: translateX(-50%) rotate(180deg); width: 24%;" }); //[cite: 1]
      positions.push({ style: "top: 8px; left: 80%; transform: translateX(-50%) rotate(180deg); width: 24%;" }); //[cite: 1]
    } else if (seats === 8) { //[cite: 1]
      positions.push({ style: "bottom: 6px; left: 25%; transform: translateX(-50%); width: 22%;" }); //[cite: 1]
      positions.push({ style: "bottom: 6px; left: 50%; transform: translateX(-50%); width: 22%;" }); //[cite: 1]
      positions.push({ style: "bottom: 6px; left: 75%; transform: translateX(-50%); width: 22%;" }); //[cite: 1]
      positions.push({ style: "top: 6px; left: 25%; transform: translateX(-50%) rotate(180deg); width: 22%;" }); //[cite: 1]
      positions.push({ style: "top: 6px; left: 50%; transform: translateX(-50%) rotate(180deg); width: 22%;" }); //[cite: 1]
      positions.push({ style: "top: 6px; left: 75%; transform: translateX(-50%) rotate(180deg); width: 22%;" }); //[cite: 1]
      positions.push({ style: "left: -10px; top: 50%; transform: translateY(-50%) rotate(90deg); width: 22%;" }); //[cite: 1]
      positions.push({ style: "right: -10px; top: 50%; transform: translateY(-50%) rotate(-90deg); width: 22%;" }); //[cite: 1]
    }

    positions.forEach(function(item) { //[cite: 1]
      const div = document.createElement("div"); //[cite: 1]
      div.className = "absolute transition-all duration-300 drop-shadow-sm"; //[cite: 1]
      div.style.cssText = item.style; //[cite: 1]
      div.innerHTML = getShapeSvgHtml(state.shapeKey, currentColor); //[cite: 1]
      seatsPlacematsWrapper.appendChild(div); //[cite: 1]
    });
  }

  function sendWhatsAppOrder(e) {
    if (e) e.preventDefault(); //[cite: 1]

    const logoNote = state.brandingMode === "file"  //[cite: 1]
      ? "Laser a fuoco (File Logo allegato - Misura " + state.logoWidthCm.toFixed(1) + " cm)" 
      : "Laser a fuoco (" + state.brandingText + " - Misura " + state.logoWidthCm.toFixed(1) + " cm)";

    const accessoriesNote = state.selectedAccessories.length > 0  //[cite: 1]
      ? state.selectedAccessories.join(", ")  //[cite: 1]
      : "Nessuno"; //[cite: 1]

    const photoLinkNote = state.tablePhotoUrl  //[cite: 1]
      ? "\n📸 *FOTO DEL MIO TAVOLO CARICATA:* " + state.tablePhotoUrl 
      : "\n📸 *FOTO TAVOLO:* (Invio foto direttamente qui in chat per il rendering)";

    const text = "Buongiorno Tabloos! Vorrei un preventivo/ordine per le tovagliette personalizzate:\n\n" +
      "🔹 *Quantità:* " + state.orderQuantity + " pezzi\n" +
      "🔹 *Sagoma:* " + (sumShape ? sumShape.textContent : state.shapeKey) + "\n" +
      "🔹 *Misura Calcolata:* " + (sumDim ? sumDim.textContent : "") + "\n" +
      "🔹 *Fronte:* " + (sumSideA ? sumSideA.textContent : "") + "\n" +
      "🔹 *Retro:* " + (sumSideB ? sumSideB.textContent : "") + "\n" +
      "🔹 *Marchiatura:* " + logoNote + "\n" +
      "🔹 *Linea Coordinata:* " + accessoriesNote + "\n" +
      "🔹 *Misure Tavolo:* " + (sumTable ? sumTable.textContent : "") +
      photoLinkNote + "\n\n" +
      "Resto in attesa della conferma del rendering e dei tempi di produzione!";

    const encoded = encodeURIComponent(text); //[cite: 1]
    const phone = WHATSAPP_PHONE.replace(/[^0-9]/g, ''); //[cite: 1]
    window.open("https://wa.me/" + phone + "?text=" + encoded, "_blank"); //[cite: 1]
  }

  function setupEventListeners() {
    const btnModePreset = document.getElementById("btn-mode-preset"); //[cite: 1]
    const btnModeCustom = document.getElementById("btn-mode-custom"); //[cite: 1]
    const containerPreset = document.getElementById("container-preset-dim"); //[cite: 1]
    const containerCustom = document.getElementById("container-custom-dim"); //[cite: 1]

    if (btnModePreset && btnModeCustom) {
      btnModePreset.addEventListener("click", function() { //[cite: 1]
        state.tableDimMode = "preset"; //[cite: 1]
        btnModePreset.className = "text-[10px] font-bold text-amber-800 underline"; //[cite: 1]
        btnModeCustom.className = "text-[10px] font-medium text-slate-500 hover:text-amber-800"; //[cite: 1]
        containerPreset.classList.remove("hidden"); //[cite: 1]
        containerCustom.classList.add("hidden"); //[cite: 1]
        calculateProportions(); //[cite: 1]
        updateRender(); //[cite: 1]
      });

      btnModeCustom.addEventListener("click", function() { //[cite: 1]
        state.tableDimMode = "custom"; //[cite: 1]
        btnModeCustom.className = "text-[10px] font-bold text-amber-800 underline"; //[cite: 1]
        btnModePreset.className = "text-[10px] font-medium text-slate-500 hover:text-amber-800"; //[cite: 1]
        containerCustom.classList.remove("hidden"); //[cite: 1]
        containerPreset.classList.add("hidden"); //[cite: 1]
        calculateProportions(); //[cite: 1]
        updateRender(); //[cite: 1]
      });
    }

    const inputCustW = document.getElementById("input-custom-width");
    const inputCustH = document.getElementById("input-custom-height");
    const inputTablePreset = document.getElementById("input-table-preset");

    if (inputCustW) inputCustW.addEventListener("input", function() { calculateProportions(); updateRender(); }); //[cite: 1]
    if (inputCustH) inputCustH.addEventListener("input", function() { calculateProportions(); updateRender(); }); //[cite: 1]
    if (inputTablePreset) inputTablePreset.addEventListener("change", function(e) { state.tablePreset = e.target.value; calculateProportions(); updateRender(); }); //[cite: 1]

    document.querySelectorAll(".seat-select-btn").forEach(function(btn) { //[cite: 1]
      btn.addEventListener("click", function() { //[cite: 1]
        document.querySelectorAll(".seat-select-btn").forEach(function(b) { //[cite: 1]
          b.className = "seat-select-btn py-2 rounded-xl border border-slate-300 font-semibold text-center text-slate-700 hover:border-amber-400"; //[cite: 1]
        });
        btn.className = "seat-select-btn py-2 rounded-xl border border-amber-600 bg-amber-700 text-white font-bold text-center shadow-sm"; //[cite: 1]
        state.tableSeats = parseInt(btn.dataset.seats); //[cite: 1]
        calculateProportions(); //[cite: 1]
        updateRender(); //[cite: 1]
      });
    });

    const inputOrderQty = document.getElementById("input-order-quantity"); //[cite: 1]
    if (inputOrderQty) { //[cite: 1]
      inputOrderQty.addEventListener("input", function(e) { //[cite: 1]
        state.orderQuantity = Math.max(1, parseInt(e.target.value) || 1); //[cite: 1]
        updateRender(); //[cite: 1]
      });
    }

    const inputTablePhotoFile = document.getElementById("input-table-photo-file"); //[cite: 1]
    const btnRemoveTablePhoto = document.getElementById("btn-remove-table-photo"); //[cite: 1]
    const tablePhotoStatus = document.getElementById("table-photo-status"); //[cite: 1]

    if (inputTablePhotoFile) { //[cite: 1]
      inputTablePhotoFile.addEventListener("change", function(e) { //[cite: 1]
        const file = e.target.files[0]; //[cite: 1]
        if (!file) return; //[cite: 1]

        if (tablePhotoStatus) { //[cite: 1]
          tablePhotoStatus.textContent = "Caricamento in corso..."; //[cite: 1]
          tablePhotoStatus.className = "text-xs font-bold text-amber-700 truncate max-w-[200px]"; //[cite: 1]
        }

        const formData = new FormData(); //[cite: 1]
        formData.append("image", file); //[cite: 1]

        fetch("https://api.imgbb.com/1/upload?key=6d207e02c98a72bde63f825224e75871", { //[cite: 1]
          method: "POST", //[cite: 1]
          body: formData //[cite: 1]
        })
        .then(response => response.json()) //[cite: 1]
        .then(data => { //[cite: 1]
          if (data && data.success) { //[cite: 1]
            state.tablePhotoUrl = data.data.url; //[cite: 1]
            if (tablePhotoStatus) { //[cite: 1]
              tablePhotoStatus.textContent = "Foto caricata (Pronta per WhatsApp)"; //[cite: 1]
              tablePhotoStatus.className = "text-xs font-bold text-emerald-700 truncate max-w-[200px]"; //[cite: 1]
            }
            if (btnRemoveTablePhoto) btnRemoveTablePhoto.classList.remove("hidden"); //[cite: 1]
            showToast("Foto tavolo pronta per l'invio su WhatsApp!");
            updateRender(); //[cite: 1]
          } else {
            throw new Error("Upload fallito"); //[cite: 1]
          }
        })
        .catch(error => { //[cite: 1]
          console.error(error); //[cite: 1]
          if (tablePhotoStatus) { //[cite: 1]
            tablePhotoStatus.textContent = "Errore upload (puoi inviarla dopo in chat)";
            tablePhotoStatus.className = "text-xs font-bold text-amber-700 truncate max-w-[200px]";
          }
          showToast("Upload fallito. Potrai allegarla direttamente su WhatsApp.");
        });
      });
    }

    if (btnRemoveTablePhoto) { //[cite: 1]
      btnRemoveTablePhoto.addEventListener("click", function() { //[cite: 1]
        state.tablePhotoUrl = null; //[cite: 1]
        if (inputTablePhotoFile) inputTablePhotoFile.value = ""; //[cite: 1]
        if (tablePhotoStatus) { //[cite: 1]
          tablePhotoStatus.textContent = "Nessun file selezionato"; //[cite: 1]
          tablePhotoStatus.className = "text-xs text-slate-500 truncate max-w-[200px]"; //[cite: 1]
        }
        btnRemoveTablePhoto.classList.add("hidden"); //[cite: 1]
        showToast("Foto rimossa"); //[cite: 1]
        updateRender(); //[cite: 1]
      });
    }

    document.querySelectorAll(".accessory-cb").forEach(function(cb) { //[cite: 1]
      cb.addEventListener("change", function() { //[cite: 1]
        const item = this.dataset.name; //[cite: 1]
        if (this.checked) { //[cite: 1]
          if (state.selectedAccessories.indexOf(item) === -1) { //[cite: 1]
            state.selectedAccessories.push(item); //[cite: 1]
          }
        } else {
          state.selectedAccessories = state.selectedAccessories.filter(function(a) { return a !== item; }); //[cite: 1]
        }
        updateRender(); //[cite: 1]
      });
    });

    const btnModeSingle = document.getElementById("view-mode-single"); //[cite: 1]
    const btnModeTable = document.getElementById("view-mode-table"); //[cite: 1]

    if (btnModeSingle && btnModeTable) {
      btnModeSingle.addEventListener("click", function() { //[cite: 1]
        state.viewMode = "single"; //[cite: 1]
        btnModeSingle.classList.add("bg-white", "shadow-sm", "text-slate-900", "font-bold"); //[cite: 1]
        btnModeSingle.classList.remove("text-slate-600"); //[cite: 1]
        btnModeTable.classList.remove("bg-white", "shadow-sm", "text-slate-900", "font-bold"); //[cite: 1]
        btnModeTable.classList.add("text-slate-600"); //[cite: 1]
        singleViewContainer.classList.remove("hidden"); //[cite: 1]
        tableSimulationContainer.classList.add("hidden"); //[cite: 1]
        updateRender(); //[cite: 1]
      });

      btnModeTable.addEventListener("click", function() { //[cite: 1]
        state.viewMode = "table"; //[cite: 1]
        btnModeTable.classList.add("bg-white", "shadow-sm", "text-slate-900", "font-bold"); //[cite: 1]
        btnModeTable.classList.remove("text-slate-600"); //[cite: 1]
        btnModeSingle.classList.remove("bg-white", "shadow-sm", "text-slate-900", "font-bold"); //[cite: 1]
        btnModeSingle.classList.add("text-slate-600"); //[cite: 1]
        singleViewContainer.classList.add("hidden"); //[cite: 1]
        tableSimulationContainer.classList.remove("hidden"); //[cite: 1]
        renderTableSimulation(); //[cite: 1]
      });
    }

    const btnSideA = document.getElementById("btn-side-a"); //[cite: 1]
    const btnSideB = document.getElementById("btn-side-b"); //[cite: 1]
    const btnFlipFace = document.getElementById("btn-flip-face"); //[cite: 1]

    function setSide(side) {
      state.activeSide = side; //[cite: 1]
      if (side === "A") { //[cite: 1]
        if (btnSideA) { btnSideA.classList.add("bg-white", "shadow-sm", "text-amber-900", "font-bold"); btnSideA.classList.remove("text-slate-600"); } //[cite: 1]
        if (btnSideB) { btnSideB.classList.remove("bg-white", "shadow-sm", "text-amber-900", "font-bold"); btnSideB.classList.add("text-slate-600"); } //[cite: 1]
        if (labelActiveSide) labelActiveSide.textContent = "Fronte (A)"; //[cite: 1]
      } else {
        if (btnSideB) { btnSideB.classList.add("bg-white", "shadow-sm", "text-amber-900", "font-bold"); btnSideB.classList.remove("text-slate-600"); } //[cite: 1]
        if (btnSideA) { btnSideA.classList.remove("bg-white", "shadow-sm", "text-amber-900", "font-bold"); btnSideA.classList.add("text-slate-600"); } //[cite: 1]
        if (labelActiveSide) labelActiveSide.textContent = "Retro (B)"; //[cite: 1]
      }
      renderColorSwatches(); //[cite: 1]
      updateRender(); //[cite: 1]
    }

    if (btnSideA) btnSideA.addEventListener("click", function() { setSide("A"); }); //[cite: 1]
    if (btnSideB) btnSideB.addEventListener("click", function() { setSide("B"); }); //[cite: 1]
    if (btnFlipFace) btnFlipFace.addEventListener("click", function() { setSide(state.activeSide === "A" ? "B" : "A"); }); //[cite: 1]

    document.querySelectorAll(".finish-tab-btn").forEach(function(btn) { //[cite: 1]
      btn.addEventListener("click", function() { //[cite: 1]
        document.querySelectorAll(".finish-tab-btn").forEach(function(b) { //[cite: 1]
          b.classList.remove("bg-amber-50", "text-amber-900", "border-amber-300", "font-bold"); //[cite: 1]
          b.classList.add("text-slate-600"); //[cite: 1]
        });
        btn.classList.add("bg-amber-50", "text-amber-900", "border-amber-300", "font-bold"); //[cite: 1]
        btn.classList.remove("text-slate-600"); //[cite: 1]

        const currentSide = state.activeSide === "A" ? state.sideA : state.sideB; //[cite: 1]
        currentSide.finish = btn.dataset.finish; //[cite: 1]
        const first = COLOR_PALETTES[currentSide.finish][0]; //[cite: 1]
        currentSide.colorHex = first.hex; //[cite: 1]
        currentSide.colorName = first.name; //[cite: 1]
        customColorPicker.value = first.hex; //[cite: 1]
        customHexLabel.textContent = first.hex.toUpperCase(); //[cite: 1]
        renderColorSwatches(); //[cite: 1]
        updateRender(); //[cite: 1]
      });
    });

    if (customColorPicker) {
      customColorPicker.addEventListener("input", function(e) { //[cite: 1]
        const currentSide = state.activeSide === "A" ? state.sideA : state.sideB; //[cite: 1]
        currentSide.colorHex = e.target.value; //[cite: 1]
        currentSide.colorName = "Custom (" + e.target.value.toUpperCase() + ")"; //[cite: 1]
        customHexLabel.textContent = e.target.value.toUpperCase(); //[cite: 1]
        renderColorSwatches(); //[cite: 1]
        updateRender(); //[cite: 1]
      });
    }

    const tabBrandText = document.getElementById("tab-brand-text"); //[cite: 1]
    const tabBrandFile = document.getElementById("tab-brand-file"); //[cite: 1]
    const boxBrandText = document.getElementById("box-brand-text"); //[cite: 1]
    const boxBrandFile = document.getElementById("box-brand-file"); //[cite: 1]

    if (tabBrandText && tabBrandFile) {
      tabBrandText.addEventListener("click", function() { //[cite: 1]
        state.brandingMode = "text"; //[cite: 1]
        tabBrandText.className = "flex-1 py-2 text-xs sm:text-sm font-bold rounded-xl bg-amber-50 text-amber-900 border border-amber-300"; //[cite: 1]
        tabBrandFile.className = "flex-1 py-2 text-xs sm:text-sm font-semibold rounded-xl bg-slate-100 text-slate-700 border border-slate-300"; //[cite: 1]
        boxBrandText.classList.remove("hidden"); //[cite: 1]
        boxBrandFile.classList.add("hidden"); //[cite: 1]
        updateRender(); //[cite: 1]
      });

      tabBrandFile.addEventListener("click", function() { //[cite: 1]
        state.brandingMode = "file"; //[cite: 1]
        tabBrandFile.className = "flex-1 py-2 text-xs sm:text-sm font-bold rounded-xl bg-amber-50 text-amber-900 border border-amber-300"; //[cite: 1]
        tabBrandText.className = "flex-1 py-2 text-xs sm:text-sm font-semibold rounded-xl bg-slate-100 text-slate-700 border border-slate-300"; //[cite: 1]
        boxBrandFile.classList.remove("hidden"); //[cite: 1]
        boxBrandText.classList.add("hidden"); //[cite: 1]
        updateRender(); //[cite: 1]
      });
    }

    const inputBrandText = document.getElementById("input-brand-text");
    if (inputBrandText) inputBrandText.addEventListener("input", function(e) { state.brandingText = e.target.value || ""; updateRender(); }); //[cite: 1]
    
    const selectBrandFont = document.getElementById("select-brand-font");
    if (selectBrandFont) selectBrandFont.addEventListener("change", function(e) { state.brandingFont = e.target.value; updateRender(); }); //[cite: 1]

    // Limite impostato nel codice a 8 cm max
    const inputLogoWidth = document.getElementById("input-logo-width-cm"); //[cite: 1]
    if (inputLogoWidth) {
      inputLogoWidth.setAttribute("max", "8.0");
      inputLogoWidth.setAttribute("min", "2.0");
      inputLogoWidth.setAttribute("step", "0.5");
      inputLogoWidth.addEventListener("input", function(e) { //[cite: 1]
        state.logoWidthCm = Math.min(8.0, parseFloat(e.target.value) || 2.0);
        if (labelLogoWidth) labelLogoWidth.textContent = state.logoWidthCm.toFixed(1) + " cm"; //[cite: 1]
        updateRender(); //[cite: 1]
      });
    }

    const inputLogoFile = document.getElementById("input-logo-file"); //[cite: 1]
    const btnRemoveLogo = document.getElementById("btn-remove-logo"); //[cite: 1]

    if (inputLogoFile) {
      inputLogoFile.addEventListener("change", function(e) { //[cite: 1]
        const file = e.target.files[0]; //[cite: 1]
        if (!file) return; //[cite: 1]
        const reader = new FileReader(); //[cite: 1]
        reader.onload = function(evt) { //[cite: 1]
          state.uploadedLogoSrc = evt.target.result; //[cite: 1]
          if (btnRemoveLogo) btnRemoveLogo.classList.remove("hidden"); //[cite: 1]
          showToast("Logo caricato! Puoi trascinarlo direttamente sulla tovaglietta.");
          updateRender(); //[cite: 1]
        };
        reader.readAsDataURL(file); //[cite: 1]
      });
    }

    if (btnRemoveLogo) {
      btnRemoveLogo.addEventListener("click", function() { //[cite: 1]
        state.uploadedLogoSrc = null; //[cite: 1]
        if (inputLogoFile) inputLogoFile.value = ""; //[cite: 1]
        btnRemoveLogo.classList.add("hidden"); //[cite: 1]
        if (tabBrandText) tabBrandText.click(); //[cite: 1]
      });
    }

    const tableStage = document.getElementById("table-stage"); //[cite: 1]
    const selectTableMaterial = document.getElementById("select-table-material"); //[cite: 1]
    if (selectTableMaterial && tableStage) {
      selectTableMaterial.addEventListener("change", function(e) { //[cite: 1]
        tableStage.classList.remove("table-noce", "table-rovere-chiaro", "table-scuro", "table-marmo", "table-ardesia"); //[cite: 1]
        tableStage.classList.add(e.target.value); //[cite: 1]
        state.tableMaterial = e.target.value; //[cite: 1]
      });
      tableStage.classList.add(state.tableMaterial); //[cite: 1]
    }

    const btnRequestQuote = document.getElementById("btn-request-quote");
    if (btnRequestQuote) btnRequestQuote.addEventListener("click", sendWhatsAppOrder); //[cite: 1]
    
    const btnStickyOrder = document.getElementById("btn-sticky-order"); //[cite: 1]
    if (btnStickyOrder) { //[cite: 1]
      btnStickyOrder.addEventListener("click", sendWhatsAppOrder); //[cite: 1]
    }
  }

  function showToast(msg) {
    const toast = document.getElementById("toast"); //[cite: 1]
    if (!toast) return; //[cite: 1]
    const msgEl = document.getElementById("toast-message");
    if (msgEl) msgEl.textContent = msg; //[cite: 1]
    toast.classList.remove("translate-y-20", "opacity-0"); //[cite: 1]
    setTimeout(function() { toast.classList.add("translate-y-20", "opacity-0"); }, 2800);
  }

  function initConfigurator() {
    svgRootElement = document.getElementById("placemat-svg"); //[cite: 1]
    svgBaseShape = document.getElementById("svg-base-shape"); //[cite: 1]
    svgFinishOverlay = document.getElementById("svg-finish-overlay"); //[cite: 1]
    svgFlipContainer = document.getElementById("svg-flip-container"); //[cite: 1]
    svgBrandingGroup = document.getElementById("svg-branding-group"); //[cite: 1]
    brandingText = document.getElementById("branding-text"); //[cite: 1]
    brandingImage = document.getElementById("branding-image"); //[cite: 1]
    shapesContainer = document.getElementById("shapes-selector-container"); //[cite: 1]
    swatchesContainer = document.getElementById("color-swatches-grid"); //[cite: 1]
    customColorPicker = document.getElementById("custom-color-picker"); //[cite: 1]
    customHexLabel = document.getElementById("custom-hex-label"); //[cite: 1]
    mirrorIndicator = document.getElementById("mirror-indicator"); //[cite: 1]

    singleViewContainer = document.getElementById("single-view-container"); //[cite: 1]
    tableSimulationContainer = document.getElementById("table-simulation-container"); //[cite: 1]
    tableTopBounds = document.getElementById("table-top-bounds"); //[cite: 1]
    seatsPlacematsWrapper = document.getElementById("seats-placemats-wrapper"); //[cite: 1]
    centerFreeSpace = document.getElementById("center-free-space"); //[cite: 1]

    tagShape = document.getElementById("preview-tag-shape"); //[cite: 1]
    tagColor = document.getElementById("preview-tag-color"); //[cite: 1]
    selectedShapeName = document.getElementById("selected-shape-name"); //[cite: 1]
    labelActiveSide = document.getElementById("label-active-side"); //[cite: 1]
    placematComputedDim = document.getElementById("placemat-computed-dim"); //[cite: 1]
    safetyCalculationText = document.getElementById("safety-calculation-text"); //[cite: 1]
    labelLogoWidth = document.getElementById("label-logo-width"); //[cite: 1]
    previewDotA = document.getElementById("preview-dot-a"); //[cite: 1]
    previewDotB = document.getElementById("preview-dot-b"); //[cite: 1]
    badgeSeatsDisplay = document.getElementById("badge-seats-display"); //[cite: 1]

    sumShape = document.getElementById("sum-shape"); //[cite: 1]
    sumDim = document.getElementById("sum-dim"); //[cite: 1]
    sumSideA = document.getElementById("sum-side-a"); //[cite: 1]
    sumSideB = document.getElementById("sum-side-b"); //[cite: 1]
    sumTech = document.getElementById("sum-tech"); //[cite: 1]
    sumTable = document.getElementById("sum-table"); //[cite: 1]
    sumAccessories = document.getElementById("sum-accessories"); //[cite: 1]
    sumQuantity = document.getElementById("sum-quantity"); //[cite: 1]
    sumTablePhoto = document.getElementById("sum-table-photo"); //[cite: 1]
    stickySummary = document.getElementById("sticky-summary"); //[cite: 1]

    injectLaserFilter();
    calculateProportions(); //[cite: 1]
    initShapeSelector(); //[cite: 1]
    renderColorSwatches(); //[cite: 1]
    setupEventListeners(); //[cite: 1]
    initInteractiveLogoDragging();
    updateRender(); //[cite: 1]
  }

  if (document.readyState === "loading") { //[cite: 1]
    document.addEventListener("DOMContentLoaded", initConfigurator); //[cite: 1]
  } else {
    initConfigurator(); //[cite: 1]
  }
})();